import { render, staticRenderFns } from "./PanelAddInfo.vue?vue&type=template&id=efd62226&"
import script from "./PanelAddInfo.vue?vue&type=script&lang=js&"
export * from "./PanelAddInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports